import { getLoadingMessage, type LoadingCopyKey } from '@/shared/copy/loading';
import { LoadingSpinnerPageState } from '@/ui/composites/LoadingSpinnerPageState';
import type { ReactElement } from 'react';

type PageLoadingFallbackProps = {
  loadingMessageKey?: LoadingCopyKey;
  message?: string;
};

export const PageLoadingFallback = ({
  loadingMessageKey = 'page',
  message,
}: PageLoadingFallbackProps): ReactElement => (
  <LoadingSpinnerPageState message={message ?? getLoadingMessage(loadingMessageKey)} />
);
